<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="loginHistorySearch" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container @refresh="refresh" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/Search';
import TableContainer from './Table/Table';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchContainer,
		TableContainer
	},
	methods: {
		refresh(currentPage = 1, pageUnit = this.groups.pageUnit) {
			this.$refs.loginHistorySearch.searchList(currentPage, pageUnit);
		}
	}
};
</script>
<style lang=""></style>
